module.exports = __webpack_public_path__ + "images/emoji/cool.fdd64883767743badbeb.png";